import ReactDatePicker from "react-date-picker";
import { Box, BoxProps } from "../Box";
import { Label } from "../Label";
import { Paragraph } from "../Paragraph";
import "./styles.css";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";

type DatePickerProps = BoxProps & {
  autoFocus?: boolean;
  value: Date | string;
  onChange: (value: any) => void;
  name?: string;
  label?: string;
  format?: string;
  maxDate?: Date;
  minDate?: Date;
  hasError?: boolean;
  errorMessage?: string;
  isRequired?: boolean;
  /**
   * Defaults to the library behaviour of opening the calendar as soon as the
   * field takes focus. Set false where the calendar would cover the input and
   * block typing, leaving the calendar icon to open it.
   */
  openCalendarOnFocus?: boolean;
  // className?: string;
};

export const DatePicker = (props: DatePickerProps) => {
  const {
    value,
    autoFocus,
    label,
    onChange,
    format,
    maxDate,
    minDate,
    errorMessage,
    hasError,
    name,
    isRequired,
    openCalendarOnFocus = true,
    // className,
    ...styleProps
  } = props;

  return (
    <Box position="relative" {...styleProps}>
      {label && (
        <Label>
          {label}
          {isRequired ? " *" : ""}
        </Label>
      )}
      <ReactDatePicker
        autoFocus={autoFocus}
        onChange={onChange}
        value={value}
        format={format}
        showLeadingZeros
        locale="en-GB"
        className={
          hasError
            ? "react-date-picker-error react-date-picker"
            : "react-date-picker"
        }
        maxDate={maxDate}
        minDate={minDate}
        name={name}
        openCalendarOnFocus={openCalendarOnFocus}
      />

      {errorMessage && (
        <Paragraph color="red.primary" fontSize="1" mt="1" textAlign="right">
          {errorMessage}
        </Paragraph>
      )}
    </Box>
  );
};
